import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

// Production config
const productionConfig = {
    apiKey: 'AIzaSyDEk7cZUSuP2EN1OzXjYzqkIWS0KByBfzI',
    authDomain: 'tfw-swapp.firebaseapp.com',
    databaseURL: 'https://tfw-swapp.firebaseio.com',
    projectId: 'tfw-swapp',
    storageBucket: 'tfw-swapp.appspot.com',
    messagingSenderId: '202603484698',
    appId: '1:202603484698:web:2db5a89acca1fb9495e3a3'
}

// Staging config
const stagingConfig = {
    apiKey: 'AIzaSyCcR1_1nuk0sKALg8BFwFC9lFEaD_ENbUo',
    authDomain: 'tfw-staging.firebaseapp.com',
    projectId: 'tfw-staging',
    storageBucket: 'tfw-staging.appspot.com',
    messagingSenderId: '416701102568',
    appId: '1:416701102568:web:75467ef6cd91778375cc5d',
    measurementId: 'G-JP3NLDZFJV'
}

// Determine environment and select appropriate config
const isProduction = window.location.hostname === 'tfw.swapp.work' ||
                      window.location.hostname === 'tfw-swapp.web.app' ||
                      window.location.hostname.includes('tfw-swapp--pre-prod')

let firebaseConfig
if (isProduction) {
    firebaseConfig = productionConfig
    console.log('🔴 Firebase: Connected to PRODUCTION environment')
} else {
    // All non-production (staging, dev, localhost) use staging config
    firebaseConfig = stagingConfig
    console.log('🟡 Firebase: Connected to STAGING environment (non-production)')
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)

const db = firebase.firestore()
const auth = firebase.auth()
const storage = firebase.storage()
const currentUser = auth.currentUser
const fv = firebase.firestore.FieldValue

export { db, storage, auth, currentUser, fv }
